module.exports = __webpack_public_path__ + "static/img/resultados.e7e486b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resultados.png
// module id = KESY
// module chunks = 1